export default __webpack_public_path__ + "static/media/bg.7fb19190.png";